import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { action } from '@ember/object';
import WarehouseSyncModel from 'cio/models/warehouse-sync';
import DS from 'ember-data';

export default class IntegrationsWarehouseRoute extends Route {
  @service store!: DS.Store;

  async model(): Promise<WarehouseSyncModel | undefined> {
    try {
      return await this.store.queryRecord('warehouse-sync', {});
    } catch (err) {
      if (err?.errors[0]?.status !== '404') {
        throw err;
      }

      return undefined;
    }
  }

  @action
  reloadModel() {
    this.refresh();
  }
}
